import React, {Fragment} from "react";
import {useState} from "react";
import _ from "lodash";

import AdditionalStudentSelection from "./../AdditionalStudentSelection";
import {frenchEnumeration} from "../utils";
import {Editor, EditorState, convertFromRaw, ContentState} from "draft-js";
import WysiwygViewer from "../utils/WysiwygViewer";

const moment = require("moment-timezone");
require("moment/locale/fr");

const getDisplayPrice = (ref, season) => {
    if (ref == undefined || season == undefined)
        return (ref || {}).display_price || "--";

    return ref.display_prices_by_season[season.id] || ref.display_price || "--";
};

const getDisplayDuration = ref => {
    if (ref == undefined) return "--";
    if (ref.duration >= 60) {
        const hours = Math.floor(ref.duration / 60);
        const minutes = ref.duration % 60;
        return `${hours}h${minutes < 10 ? "0" : ""}${minutes}`;
    } else if (ref.duration > 0) {
        return `${ref.duration} min`;
    } else {
        return "";
    }
};

const ActivityChoice = ({
                            schoolName,
                            adhesionPrices,
                            selectedActivities,
                            activityRefs,
                            activityRefsChildhood,
                            activityRefsCham,
                            allActivityRefs,
                            allActivityRefKinds,
                            currentUserIsAdmin,
                            handleAddActivity,
                            handleRemoveActivity,
                            validation,
                            additionalStudents,
                            handleChangeAdditionalStudent,
                            infos,
                            season,
                            adhesionEnabled,
                            packs,
                            handleRemovePack,
                            handleAddPack,
                            selectedPacks,
                            pricingInfo,
                            selectedFormulas,
                            formulas,
                            selectedFormulaActivities,
                        }) => {
    const seasonStart = moment(season.start);
    const isInAgeRange = a => {
        if (a.activity_type === "child") {
            const birthday = moment(infos.birthday);
            const nextBirthday = moment(infos.birthday).year(seasonStart.year());
            const age = nextBirthday.diff(birthday, "years");

            return a.from_age <= age && age < a.to_age;
        } else {
            const seasonEnd = moment(season.end);
            // const seasonEnd = moment(); // tmp : reset the calculated age to "relative from today"
            const userAge = seasonEnd.diff(moment(infos.birthday), "years");
            return userAge >= a.from_age && userAge <= a.to_age;
        }
    };

    // Only display activities that are suitable for student
    const filteredActivityRefs = activityRefs.filter(isInAgeRange);
    const filteredActivityRefsChildhood = activityRefsChildhood.filter(isInAgeRange);
    const cantSelectChildhood =
        _.intersection(
            selectedActivities,
            filteredActivityRefsChildhood.map(aref => aref.id),
        ).length > 0;
    const unpopularActivities = activityRefs.filter(ref => ref.is_unpopular);
    const unpopularActivityChosen =
        _.intersection(
            unpopularActivities.map(a => a.id),
            selectedActivities,
        ).length > 0;
    const unpopularActivitiesSelected = unpopularActivities.filter(a => selectedActivities.includes(a.id));

    // Check is CHAM is only visible to admin
    if (!currentUserIsAdmin) {
        activityRefsCham = activityRefsCham.filter(ar => ar.is_visible_admin === true);
    }

    const renderChildrenAccompaniments = () => {
        /* additionalStudents only exist here in Edit Mode while adding activities */
        if (additionalStudents && additionalStudents.length > 0) {
            const family = {};

            _.map(infos.user.family_member_users, member => {
                family[member.member_id] = {
                    id: member.id,
                    link: member.link,
                    first_name: member.member.first_name,
                    last_name: member.member.last_name,
                };
            });

            return (
                <div id="tab-2" className="tab-pane text-justify">
                    <AdditionalStudentSelection
                        family={family}
                        additionalStudents={additionalStudents}
                        handleChangeAdditionalStudent={(index, value) =>
                            handleChangeAdditionalStudent(index, value)
                        }
                    />
                </div>
            );
        }
    };
    const groupedRefs = _.groupBy(filteredActivityRefs.filter(r => r.substitutable === true), "kind");

    // Duration filter ---------------------------------------------------------------------------------------------------------------------------------------------
    const [durationFilter, setDurationFilter] = useState(null);
    const handleDurationFilterClick = () => {
        setDurationFilter(durationFilter === 'asc' ? 'desc' : 'asc');
    };

    // Search filter ---------------------------------------------------------------------------------------------------------------------------------------------
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Display the Activities and Packs ---------------------------------------------------------------------------------------------------------------------------------------------
    function generateActivityRow(item, key, isPack = false, isSelected = false) {
        const label = item.label;
        const duration = item.duration;
        const price = item.price;

        const uniqueId = isPack ? `p${item.id}` : `a${item.id}`;
        const isItemSelected = selectedActivitiesAndPacks.some(selectedItem => selectedItem.id === item.id && selectedItem.isPack === isPack);
        const iconClass = isItemSelected && !isSelected ? "fas fa-check" : (isSelected ? "fas fa-minus" : "fas fa-plus");
        const handleAction = () => {
            if (isSelected) {
                if (isPack) {
                    handleRemovePack(key, item.pricing_category_id);
                } else {
                    handleRemoveActivity(item.id);
                }
            } else {
                const handleAdd = isPack ? () => handleAddPack(key, item.pricing_category_id) : () => handleAddActivity(item.id);
                handleAdd();
            }
        };

        const buttonStyle = isSelected
            ? {
                borderRadius: "50%",
                color: "white",
                backgroundColor: "#00334A",
                border: 0,
                width: "32px",
                height: "32px"
            }
            : isItemSelected
                ? {
                    borderRadius: "50%",
                    color: "white",
                    backgroundColor: "#86D69E",
                    border: 0,
                    width: "32px",
                    height: "32px"
                }
                : {
                    borderRadius: "50%",
                    color: "white",
                    backgroundColor: "#0079BF",
                    border: 0,
                    width: "32px",
                    height: "32px"
                };

        return (
            <React.Fragment key={uniqueId}>
                <tr style={{color: "rgb(0, 51, 74)"}}>
                    <td style={{fontWeight: "bold"}}>{label}</td>
                    <td className="text-center">{duration}</td>
                    <td className="text-center">{price}</td>
                    <td>
                        <div className="btn-group-horizontal pull-right btn-group" role="group">
                            <button onClick={handleAction} style={buttonStyle} disabled={isItemSelected && !isSelected}>
                                <i className={iconClass}></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
        );
    }

    const individualRefs = _.uniqBy(
        _.union(
            filteredActivityRefsChildhood,
            activityRefs.filter(ar => {
                const suitableActivityRefs = ar.substitutable === false && isInAgeRange(ar);
                if (currentUserIsAdmin) {
                    return suitableActivityRefs;
                }
                return suitableActivityRefs && ar.is_visible_admin !== true;
            }),
        ), "id"
    );

    const availableActivities = _.uniqBy([...Object.values(groupedRefs).flat(1), ...individualRefs, ...activityRefsCham].map(item => {
        return {
            id: item.id,
            key: null,
            label: item.display_name,
            duration: getDisplayDuration(item),
            price: `${getDisplayPrice(item, season)} €`,
            isPack: false,
            isSelected: false,
        };
    }), a => a.id);
    const availablePacks = Object.entries(packs).flatMap(([key, packArray]) => packArray.map(item => {
        return {
            id: item.id,
            pricing_category_id: item.pricing_category.id,
            key: key,
            label: `${item.activity_ref.display_name} - ${item.pricing_category.name}`,
            duration: getDisplayDuration(item.activity_ref),
            price: `${item.price} €`,
            isPack: true,
            isSelected: false,
        };
    }));
    let availableActivitiesAndPacks = [...availableActivities, ...availablePacks];
    if (durationFilter) {
        availableActivitiesAndPacks.sort((a, b) => {
            const durationA = parseInt(a.duration, 10);
            const durationB = parseInt(b.duration, 10);

            return isNaN(durationA) ? 1 :
                isNaN(durationB) ? -1 :
                    durationFilter === 'asc' ? durationA - durationB :
                        durationB - durationA;
        });
    }
    if (searchTerm) {
        availableActivitiesAndPacks = availableActivitiesAndPacks.filter(item => {
            return item.label.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }

    const selectedActivitiesArray = selectedActivities.map(activityId => {
        const selectedActivity = _.find(allActivityRefs, ar => ar.id == parseInt(activityId, 10));
        return {
            id: selectedActivity.id,
            key: null,
            label: selectedActivity.display_name,
            duration: getDisplayDuration(selectedActivity),
            price: `${getDisplayPrice(selectedActivity, season)} €`,
            isPack: false,
            isSelected: true,
        };
    });
    const selectedPacksArray = Object.keys(selectedPacks).flatMap(key => selectedPacks[key].map(packId => {
        const item = packs[key].find(p => p.pricing_category.id === packId);
        return {
            id: item.id,
            pricing_category_id: item.pricing_category.id,
            key: key,
            label: `${item.activity_ref.display_name} - ${item.pricing_category.name}`,
            duration: getDisplayDuration(item.activity_ref),
            price: `${item.price} €`,
            isPack: true,
            isSelected: true,
        };
    }));

    const selectedFormulasArray = selectedFormulas.map(formulaId => {
        const formula = formulas.find(f => f.id === formulaId);
        if (!formula) return null;

        return {
            id: formula.id,
            key: null,
            label: formula.name,
            duration: "",
            price: formula.formule_pricings && formula.formule_pricings[0]
                ? `${formula.formule_pricings[0].price} €`
                : "--",
            isFormula: true,
            isSelected: true,
            formulaActivities: selectedFormulaActivities[formula.id] || []
        };
    }).filter(Boolean);

    const selectedActivitiesAndPacks = [...selectedActivitiesArray, ...selectedPacksArray];
    const allSelectedItems = [...selectedActivitiesAndPacks, ...selectedFormulasArray];

    const totalSelectedPrice = allSelectedItems.reduce((acc, item) => {
        const price = parseFloat(item.price.replace(" €", "").replace("--", "0"));
        return isNaN(price) ? acc : acc + price;
    }, 0);

    const selectedActivitiesAndPacksDisplay = selectedActivitiesAndPacks.map((item) => {
        return generateActivityRow(item, item.key, item.isPack, item.isSelected);
    });

    const selectedFormulasDisplay = selectedFormulasArray.map((formula) => (
        <Fragment key={`formula-${formula.id}`}>
            <tr style={{ color: "rgb(0, 51, 74)", backgroundColor: "#f5f5f5" }}>
                <td style={{ fontWeight: "bold" }}>
                    Formule : {formula.label}
                </td>
                <td className="text-center">-</td>
                <td className="text-center">{formula.price}</td>
                <td></td>
            </tr>
            {formula.formulaActivities.map(activityId => {
                const activityRef = allActivityRefs.find(a => a.id === activityId);
                return (
                    <tr key={`formula-activity-${formula.id}-${activityId}`} style={{ color: "rgb(0, 51, 74)" }}>
                        <td style={{ paddingLeft: "30px" }}>
                            {activityRef.display_name}
                        </td>
                        <td className="text-center">{getDisplayDuration(activityRef)}</td>
                        <td className="text-center">-</td>
                        <td></td>
                    </tr>
                );
            })}
        </Fragment>
    ));

    const availableActivitiesAndPacksDisplay = availableActivitiesAndPacks.map((item) => {
        return generateActivityRow(item, item.key, item.isPack, item.isSelected);
    });

    return (
        <Fragment>
            {/*Message modifiable dans les paramètres de parcours d'inscription*/}
            {pricingInfo && (
                <div className="row pl-3 ml-0">
                    <div className="alert alert-info col-12 row d-inline-flex align-items-center p-3 w-100"
                            style={{border: "1px solid #0079BF", borderRadius: "5px", color: "#0079BF"}}>
                        <div className="col-1 p-0 text-center">
                            <i className="fas fa-info-circle"></i>
                        </div>
                        <WysiwygViewer
                            className="col-11 p-0"
                            wysiwygStrData={pricingInfo}
                        />
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-xs-12 col-lg-6">
                    <div>
                        <h3 className="mb-4" style={{color: "#8AA4B1"}}>Choix de l'activité</h3>
                        <div className="d-inline-flex justify-content-between mt-1 mb-2 w-100">
                            <div>
                                <button className="btn btn-xs" style={{
                                    borderRadius: '40px',
                                    border: '1px solid #00334A',
                                    color: '#00334A',
                                    padding: '4px 10px'
                                }} onClick={handleDurationFilterClick}>
                                    Durée <i
                                    className={`fas fa-caret-${durationFilter === 'asc' ? 'up' : 'down'}`}></i>
                                </button>
                            </div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                borderRadius: '40px',
                                border: '0',
                                color: "#8AA4B1",
                                padding: '4px 10px',
                                backgroundColor: 'white'
                            }}>
                                <input
                                    type="text"
                                    placeholder="Rechercher"
                                    style={{border: 'none', backgroundColor: 'transparent'}}
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                                <i className="fas fa-search"></i>
                            </div>
                        </div>
                    </div>
                    <div>
                        <table className="table table-striped" style={{borderRadius: '12px', overflow: 'hidden'}}>
                            <thead>
                            <tr style={{backgroundColor: "#00334A", color: "white"}}>
                                <th className="pl-4">Activité</th>
                                <th>Durée</th>
                                <th>Tarif estimé</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {availableActivitiesAndPacksDisplay}
                            </tbody>
                        </table>
                    </div>
                </div>


                <div className="col-xs-12 col-lg-6">

                    <div>
                        <h3 style={{color: "#8AA4B1"}}>Récapitulatif</h3>
                    </div>
                    <div>
                        <table className="table table-striped" style={{borderRadius: '12px', overflow: 'hidden'}}>
                            <thead>
                            <tr style={{backgroundColor: "#00334A", color: "white"}}>
                                <th className="pl-4">Activité</th>
                                <th>Durée</th>
                                <th>Tarif estimé</th>
                                <th></th>
                            </tr>
                            </thead>

                            {selectedActivitiesAndPacksDisplay.length === 0 && selectedFormulasDisplay.length === 0 ? (
                                <tbody>
                                <tr>
                                    <td colSpan="4" className="text-center">aucune activité sélectionnée</td>
                                </tr>
                                </tbody>
                            ) : (
                                <tbody>
                                {selectedFormulasDisplay}

                                {selectedActivitiesAndPacksDisplay}

                                <tr>
                                    <td colSpan="2" style={{fontWeight: "bold"}} className="text-right">Total
                                        estimé
                                    </td>
                                    <td colSpan="2"
                                        className="text-center">{isNaN(totalSelectedPrice) ? "--" : totalSelectedPrice} €
                                    </td>
                                </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>

                {unpopularActivityChosen && (
                    <div className="alert alert-danger">
                        <div className="m-b-sm">
                            Les inscriptions aux activités suivantes sont
                            soumises à un nombre minimum d'élèves par cours:
                        </div>
                        <ul>
                            {unpopularActivitiesSelected.map(unpopularA => {
                                return (
                                    <li key={unpopularA.id}>
                                        {unpopularA.display_name}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}


                <div className="col-lg-12 text-center">
                    {renderChildrenAccompaniments()}
                </div>
            </div>


        </Fragment>
    )
        ;
};

export default ActivityChoice;
